<script lang="ts" setup>
import { useContextsStore } from '../stores/contexts'

const user = useSupabaseUser()
const { signOut } = useAuth()
const contextsStore = useContextsStore()
const { isDesktop } = useDeviceType()

const handleSignout = () => {
  signOut()
}
</script>

<template>
  <section class="flex flex-col gap-4 h-full content-between">
    <!-- Top -->
    <div class="flex-1">
      <UButton
        v-if="isDesktop"
        variant="ghost"
        class="p-2 w-full mb-4 overflow-hidden flex gap-2 items-center"
        color="neutral"
        size="lg"
        @click="contextsStore.openContextSelector"
      >
        <UIcon
          name="i-mingcute-classify-line"
          size="24"
          class="ml-auto text-primary"
        />
        <!--         <div class="bg-primary rounded-full w-6 h-6" /> -->
        <span class="flex-1 text-left truncate">
          {{ contextsStore.currentContext?.name }}
        </span>
      </UButton>
      <USeparator v-if="isDesktop" class="mb-4" />
      <GeneralNavigation />
    </div>
    <!-- Bottom -->
    <div class="space-y-4">
      <SponsorButton />
      <div v-if="user">
        <UButton
          variant="outline"
          class="w-full px-4 py-2 overflow-hidden"
          size="xl"
          color="neutral"
          icon="i-mingcute-exit-line"
          :label="$t('auth.logout')"
          @click="handleSignout()"
        />
      </div>
      <UButton
        v-else
        variant="solid"
        class="w-full px-4 py-2 overflow-hidden"
        color="primary"
        size="lg"
        to="/auth"
        icon="i-mingcute-refresh-4-line"
        :label="$t('sync.sync_data')"
      />
      <InstallPwaButton size="xl" class="w-full" />
      <footer class="flex gap-2 flex-wrap">
        <ULink to="/terms" target="_blank" class="text-xs underline">
          {{ $t('terms.short_link') }}
        </ULink>
        <ULink to="/privacy" target="_blank" class="text-xs underline">
          {{ $t('privacy.short_link') }}
        </ULink>
        <ULink
          to="mailto:hello@minimind.es"
          target="_blank"
          class="text-xs underline"
        >
          {{ $t('contact') }}
        </ULink>
      </footer>
    </div>
  </section>
</template>
